import { render, staticRenderFns } from "./DiagnosticoSocioambientalV2.vue?vue&type=template&id=7dbe1b66&lang=pug"
import script from "./DiagnosticoSocioambientalV2.vue?vue&type=script&lang=js"
export * from "./DiagnosticoSocioambientalV2.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoSocioambientalV2.vue?vue&type=style&index=0&id=7dbe1b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports